/**
 * @generated SignedSource<<f54282715ec1cad5485b1d453da95e95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopicCommentsFormTopicFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "TopicCommentsFormTopicFragment";
};
export type TopicCommentsFormTopicFragment$key = {
  readonly " $data"?: TopicCommentsFormTopicFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicCommentsFormTopicFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicCommentsFormTopicFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "f1a49fa57411e7100955c75faf835a12";

export default node;
